class newProductMedia extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    const mainSlider = this.querySelector(".mainSlider");
    const thumbSlider = this.querySelector(".thumbSlider");

    // Initialize thumb slider
    var swiper = new Swiper(thumbSlider, {
      spaceBetween: 10,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
      pagination: {
        el: ".swiper-pagination",
        type: "custom",
        renderCustom: (swiper, current, total) => {
          return current + " of " + total;
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    // Initialize main slider with navigation arrows
    var swiper2 = new Swiper(mainSlider, {
      spaceBetween: 10,
      autoHeight: true,
      thumbs: {
        swiper: swiper,
      },
      navigation: {
        nextEl: ".main-slider-next",
        prevEl: ".main-slider-prev",
      },
    });

    // Listen for variant image update
    document.addEventListener("arvo:variant-image-update", (e) => {
      swiper2.slideTo(0);

      mainSlider
        .querySelectorAll(".swiper-slide-active img")
        .forEach((item) => {
          item.src = e.detail.src;
          item.srcset = e.detail.src;
        });
    });

    // Handle media pause on slide change
    swiper2.on("slideChange", function () {
      pauseAllMedia();
    });

    // Handle first thumbnail click
    const first_thumb = thumbSlider.querySelector('[data-index="thumb-1"]');
    if (!first_thumb) return;
    first_thumb.addEventListener("click", () => {
      const orignal_image = first_thumb.getAttribute("data-orignal-image");

      mainSlider
        .querySelectorAll(".swiper-slide-active img")
        .forEach((item) => {
          item.src = orignal_image;
          item.srcset = orignal_image;
        });
    });
  }

  connectedCallback() {
    this.init();
  }
}

customElements.define("new-media-gallery", newProductMedia);
